import {fetchGet} from "../../requests/NetworkRequestAuth0";
import {uri} from "./AppRequest";

export const findVenueInvoices = (
    venueId,
    successMethod,
    errorMethod,
    getAccessTokenSilently
) => {
    fetchGet(
        uri + "/venue/" + venueId + "/invoices",
        successMethod,
        errorMethod,
        getAccessTokenSilently);
};

export const findVenueInvoiceDetail = (
    venueId,
    invoiceId,
    successMethod,
    errorMethod,
    getAccessTokenSilently
) => {
    fetchGet(
        uri + "/venue/" + venueId + "/invoice/" + invoiceId + "/details",
        successMethod,
        errorMethod,
        getAccessTokenSilently);
};
